import React from 'react';
import last from 'lodash/last';
import { withStyles } from '@material-ui/core/styles';
import { ListItem, ListItemText, Checkbox, Radio, Typography } from '@material-ui/core/';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const getPaddingLeft = (level) => {
    return level * 27;
}

const styles = theme => ({
    rootClass: {
        display: 'none',
        fontSize: '12px'
    },
    StyledTreeNode: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        transitionDuration: '300ms',
        height: '0',
        padding: '0',
        color: 'transparent',
        '& svg.MuiSvgIcon-root': {
            fontSize: '16px',
            fill: '##6EA0D7'
        },
    },
    NodeIcon: {
        fontSize: '12px',
        marginRight: '5px',
    },
    searchedNode: {
        backgroundColor: '#ddedff'
    },
    padding0: {
        padding: '0px',
        '& path': {
            fill: '#6EA0D7'
        }
    },
    listItemText: {
        paddingLeft: '5px !important',
        '& p': {
            fontSize: '12px',
            color: '#656565'
        }
    },
    iconStyle: {
        color: '#6EA0D7',
    },
    iconBorder: {
        border: '1px solid #E6EDF5',
        borderRadius: '1px',
        height: '20px',
        width: '20px',
        marginRight: '9px',
        textAlign: 'center',
        backgroundColor: 'white'
    },
    leafColor: {
        color: '#1a518a !important'
    },
    soloCheckbox: {
        padding: 0,
        marginLeft: '29px',
        '& path': {
            fill: '#6EA0D7'
        }
    }
});

let addCheckToParent = (node, props) => {
    return <Checkbox
        key={Math.random()}
        onClick={(e) => listItemHandler(e, node, props, 'node')}
        className={props.classes.padding0}
        color="primary"
        checked={node.isChecked}
        indeterminate={(node.isChecked && !node.isSelected)} />
        ;
}

const getNodeLabel = (node) => {
    let label = node.path.split('/')
    return last(label) === '' ? '/' : last(label)
}

const leafColor = (node, classes) => {
    return node.type === 'leaf' ? '#1a518a ' : '#656565';
}

const listItemHandler = async (e, node, props, clicked = '') => {
    if (!e.defaultPrevented) {
        if (clicked === 'node') {
            e.defaultPrevented = true;
            await props.onNodeSelect(node);
            if (!node.isOpen) props.onToggle(node);
        } else {
            if (node.type === 'leaf') {
                props.onNodeSelect(node);
            } else {
                props.onToggle(node);
            }
        }
    }
}

const TreeNode = (props) => {
    const { node, getChildNodes, level, classes, treeType } = props;
    let listEnd = []
    let rootClass = node.isRoot ? '' : '';
    if (node.type === 'leaf') {
        listEnd = treeType === 'single' ?
            <Radio
                className={classes.padding0}
                color="primary"
                checked={node.isSelected} />
            :
            <Checkbox
                className={classes.soloCheckbox}
                color="primary"
                checked={node.isChecked} />
    }
    else {
        if (node.children.length > 0) {
            listEnd.push(node.isOpen || node.isSearched || node.isSearchedParent
                ? <div key={Math.random()} className={classes.iconBorder}><FontAwesomeIcon className={classes.iconStyle} icon={['fal', 'minus']} /></div>
                : <div key={Math.random()} className={classes.iconBorder}><FontAwesomeIcon className={classes.iconStyle} icon={['fal', 'plus']} /></div>);
        }
        if (treeType === 'multi') {
            listEnd.push(addCheckToParent(node, props))
        }
    }
    return (
        <React.Fragment>
            <ListItem key={node.path + '_item'} className={[classes.padding0, rootClass, node.isSearched ? classes.searchedNode : ''].join(' ')} onClick={(e) => listItemHandler(e, node, props)} button>
                <div className={`${classes.StyledTreeNode} node`} style={{ paddingLeft: `${getPaddingLeft(level)}px` }}>
                    {listEnd}
                    <ListItemText
                        className={classes.listItemText} inset
                        disableTypography
                        primary={<Typography style={{ color: leafColor(node) }}>{getNodeLabel(node)}</Typography>}
                    />
                </div>
            </ListItem>

            {(node.isOpen || node.isSearched || node.isSearchedParent) && getChildNodes(node).map(childNode => (
                <TreeNode
                    {...props}
                    key={childNode.nodeId}
                    node={childNode}
                    level={level + 1}
                />
            ))}

        </React.Fragment>
    );
}
TreeNode.defaultProps = {
    level: 0,
};

export default withStyles(styles)(TreeNode);